import { IOrderGroup } from '../../coreDomainsModule/entities/IOrderGroup';

/**
 * 発注グループのデータを生成するファクトリークラス
 */
export class OrderGroupFactory {
  /**
   * IOrderGroupを生成する
   * 空文字などをundefinedに置き換える
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IOrderGroup> = {}): IOrderGroup => {
    const orderGroup: IOrderGroup = {
      orderGroupId: initialData.orderGroupId ?? '',
      orderGroupName: initialData.orderGroupName ?? '',
      invoiceNumber: initialData.invoiceNumber ?? undefined,
      destinationName: initialData.destinationName ?? undefined,
      upperLimitQuantity: initialData.upperLimitQuantity ?? 0,
      memo: initialData.memo ?? undefined,
      eta: initialData.eta ?? undefined,
      linkedOrderCount: initialData.linkedOrderCount ?? 0,
      totalLinkedOrderAmount: initialData.totalLinkedOrderAmount ?? 0,
    };
    return orderGroup;
  };
}
